import { render, staticRenderFns } from "./ProducerSubscriptions.vue?vue&type=template&id=93de1008&scoped=true&"
import script from "./ProducerSubscriptions.vue?vue&type=script&lang=js&"
export * from "./ProducerSubscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93de1008",
  null
  
)

export default component.exports